import { render } from "./SpondMatches.vue?vue&type=template&id=57aae7ea"
import script from "./SpondMatches.vue?vue&type=script&lang=ts"
export * from "./SpondMatches.vue?vue&type=script&lang=ts"
script.render = render

export default script